import { API_URL } from './comun';

export const SERVICIO_REPORTE = {
    ejecutivos: {
        listar: `${API_URL}reportes/ejecutivos`,
        exportar: `${API_URL}reportes/ejecutivos/excel`
    }
}
